var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0-1.742A7.254 7.254 0 0 1 4.742 12 7.254 7.254 0 0 1 12 4.742 7.254 7.254 0 0 1 19.258 12 7.254 7.254 0 0 1 12 19.258m-1.178-2.96 6.264-6.213a.436.436 0 0 0 .002-.616l-.818-.824a.435.435 0 0 0-.616-.003l-5.13 5.089-2.17-2.188a.435.435 0 0 0-.615-.002l-.825.818a.436.436 0 0 0-.002.616l3.294 3.32c.17.172.446.173.616.003"
  })));
};
export default SvgCheckCircle;